module.exports = __webpack_public_path__ + "img/tag2.344865d7.png";